import { dispatch, getAppState } from 'app/store/configureStore';
import { authUserAddFeatureToSeenMeta } from 'app/rest/effects/authUser/authUserAddFeatureToSeenMeta';
import { EFeature } from 'app/types/rest/IUserMeta';
import {
    getIsNewFeatureAsidePanelColumnTipsSeen
} from '../../../../store/model/authUser/selectors/featuresSeen/getIsNewFeatureAsidePanelColumnTipsSeen';
import { getActiveCardId } from '../../../../store/router/selectors/getActiveCardId';
import { getActiveBoardId } from '../../../../store/model/selectors/getActiveBoardId';
import { getBoardCards } from '../../../../store/model/selectors/getBoardCards';
import { cardOpen } from '../../base/effects/cardOpen';
import { setHintCanShow } from '../../hints/effects/setHintCanShow';
import { EHintKey } from '../../hints';
import {
    ASIDE_PANE_COMMENTS_COLUMN_HIGHLIGHT_ANIMATION
} from '../../aside_panel/asidePanel/components/AsidePanelCommentsColumnViewButton/constants';
import { resetHint } from '../../hints/effects/resetHint';
import { getBoardUserRecentCards } from '../../../../store/model/board/selectors/getBoardUserRecentCards';
import { TCardId } from '../../../../types/types';
import { getCard } from '../../../../store/model/selectors/getCard';
import { root } from '../../../../store/constants';

let classNamePage = 'page--knb4558';

export const onOpenTipsKNB4558AsidePanelColumn = () => {
    document.body.classList.add(classNamePage);
    const state = getAppState();
    const activeBoardId = getActiveBoardId(state);
    const boardCards = getBoardCards(state, activeBoardId);
    if (boardCards && boardCards.length) {
        setTimeout(() => {
            const button = document.querySelector('.updates-tips__text button') as HTMLElement;
            if (button) {
                button.style.display = 'block';
                button.onclick = onOpenAsidePanelKNB4558AsidePanelColumn;
            }
        }, 0);
    }
};

export const onCloseTipsKNB4558AsidePanelColumn = () => {
    setTimeout(() => {
        document.body.classList.remove(classNamePage);
    }, ASIDE_PANE_COMMENTS_COLUMN_HIGHLIGHT_ANIMATION);
    dispatch(authUserAddFeatureToSeenMeta(EFeature.ASIDE_PANEL_COLUMN_TIPS_SEEN));
    root.App.controller.removeUpdatesTips();
};

export const onOpenAsidePanelKNB4558AsidePanelColumn = (e: MouseEvent) => {
    e.stopPropagation();
    const state = getAppState();
    let cardId = getActiveCardId(state);
    if (!cardId) {
        const activeBoardId = getActiveBoardId(state);
        const boardCards = getBoardCards(state, activeBoardId);
        const recentCards = getBoardUserRecentCards(activeBoardId);
        for (let i = 0; i < recentCards.length; i++) {
            const card = getCard(state, recentCards[i]);
            if (card) {
                cardId = card.id;
                break;
            }
        }
        if (!cardId) {
            cardId = boardCards && boardCards[0] && boardCards[0].id;
        }
        if (cardId) {
            setTimeout(() => {
                dispatch(cardOpen(cardId));
            });
        }
    }
    dispatch(resetHint(EHintKey.ASIDE_COLUMN_TOGGLE));
    const interval = setInterval(() => {
        if (getCard(getAppState(), cardId).isFullLoaded) {
            dispatch(setHintCanShow(EHintKey.ASIDE_COLUMN_TOGGLE));
            setTimeout(() => {
                onCloseTipsKNB4558AsidePanelColumn();
            }, 0);
            clearInterval(interval);
        }
    }, 100);
};

export const isNewKNB4558AsidePanelColumn = () => {
    return getIsNewFeatureAsidePanelColumnTipsSeen(getAppState());
};
